import React from 'react';
import { Chip, Stack } from '@mui/material';
import type {
  InvoiceImportDirection,
  InvoiceImportDirectionSource,
} from '../Types/invoiceImport.types';
import {
  getInvoiceDirectionLabel,
  getInvoiceDirectionSourceLabel,
} from '../Utils/invoiceDirection';

interface InvoiceDirectionBadgeProps {
  direction: InvoiceImportDirection;
  source: InvoiceImportDirectionSource;
  size?: 'small' | 'medium';
  showSource?: boolean;
}

const DIRECTION_COLORS: Record<
  InvoiceImportDirection,
  'success' | 'error' | 'warning'
> = {
  purchase: 'success',
  sales: 'error',
  unknown: 'warning',
};

const InvoiceDirectionBadge: React.FC<InvoiceDirectionBadgeProps> = ({
  direction,
  source,
  size = 'small',
  showSource = true,
}) => (
  <Stack direction="row" spacing={0.75} useFlexGap flexWrap="wrap">
    <Chip size={size} color={DIRECTION_COLORS[direction]} label={getInvoiceDirectionLabel(direction)} />
    {showSource ? (
      <Chip size={size} variant="outlined" color="default" label={getInvoiceDirectionSourceLabel(source)} />
    ) : null}
  </Stack>
);

export default InvoiceDirectionBadge;
